import { sectionPage } from 'src/services/ClientApi'
import { SET_CLIENT_SECTIONS } from './types'

export const clientSections = (language) => async (dispatch) => {
  try {
    const section = await sectionPage(language)
    dispatch({ type: SET_CLIENT_SECTIONS, payload: section?.data })
  } catch (error) {
    throw error
  }
}
